export const STATUS_META = {
  pending: { label: "در انتظار بررسی", cls: "bg-amber-100 text-amber-800" },
  published: { label: "منتشر شده", cls: "bg-green-100 text-green-800" },
  needsRevision: { label: "نیاز به اصلاح", cls: "bg-orange-100 text-orange-800" },
  rejected: { label: "رد شده", cls: "bg-red-100 text-red-800" },
};

export const STATUS_TABS = [
  { value: "", label: "همه" },
  { value: "pending", label: "در انتظار بررسی" },
  { value: "published", label: "منتشر شده" },
  { value: "needsRevision", label: "نیاز به اصلاح" },
  { value: "rejected", label: "رد شده" },
];
